

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { RQRamittanceSetup } from "../../components/RQRamittanceSetup";


export const RQRamittanceSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="RQ"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "RQ", navigateTo: "/taxes/remittance/rq" },
      ]}
      mainContents={<RQRamittanceSetup />}
    />
  );
};
